import classnames from 'classnames'
import RadioList from './RadioList'

import './inlineRadioList.scss'


const InlineRadioList = props => <RadioList {...props} className={classnames('inline-radio-list', props.className)} />

export default InlineRadioList
